import { render, staticRenderFns } from "./activityEditSemesterBatches.html?vue&type=template&id=70e1551c&scoped=true&external"
import script from "./activityEditSemesterBatches.vue?vue&type=script&lang=js"
export * from "./activityEditSemesterBatches.vue?vue&type=script&lang=js"
import style0 from "./activityEditSemesterBatches.css?vue&type=style&index=0&id=70e1551c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e1551c",
  null
  
)

export default component.exports